import { ApolloClient, InMemoryCache } from "@apollo/client";
import { SetContextLink } from "@apollo/client/link/context";
import UploadHttpLink from "apollo-upload-client/UploadHttpLink.mjs";

export default function createApolloClient() {
	const httpLink = new UploadHttpLink({
		uri: import.meta.env.VITE_APP_SERVER_URL + "/graphql",
	});

	const authLink = new SetContextLink(({ headers }) => {
		const token = localStorage.getItem("token");
		return {
			headers: {
				...headers,
				authorization: token ? `Bearer ${token}` : "",
			},
		};
	});

	return new ApolloClient({
		cache: new InMemoryCache(),
		fetchOptions: {
			mode: "no-cors",
		},
		link: authLink.concat(httpLink),
		// todo enable cache later
		defaultOptions: {
			watchQuery: {
				fetchPolicy: "no-cache",
				errorPolicy: "ignore",
			},
			query: {
				fetchPolicy: "no-cache",
				errorPolicy: "all",
			},
		},
	});
}
